import { render, staticRenderFns } from "./QuoteParticulars.vue?vue&type=template&id=687c1e53"
import script from "./QuoteParticulars.vue?vue&type=script&lang=js"
export * from "./QuoteParticulars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports